import * as React from "react";
import type { SVGProps } from "react";
const SvgPendingClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17" {...props}
  >
    <g stroke="#78909C" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2.5a6 6 0 1 1 0 12M5.95 14.133a6 6 0 0 1-1.805-1.038M4.145 3.905A6 6 0 0 1 5.95 2.867M2.096 7.459a6 6 0 0 1 .711-1.957M2.096 9.54c.123.703.367 1.362.711 1.957" />
      <path d="M7.813 5.824v3.1l2.437 1.487" />
    </g>
  </svg>
);
export default SvgPendingClock;
